import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    name: "Dashboard",
    path: "/Dashboard",
    component: () => import("../components/DashBoard.vue")
  },
  {
    name: "FormView",
    path: "/FormView",
    component: () => import("../components/Forms/FormView.vue")
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
